import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import { PortfolioProvider } from "@/context/PortfolioContext";
import PageShell from "@/components/site/PageShell";
import Cursor from "@/components/site/Cursor";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ServicesPage from "@/pages/Services";
import IndustriesPage from "@/pages/Industries";
import ProcessPage from "@/pages/Process";
import ContactPage from "@/pages/Contact";
import PortfolioPage from "@/pages/Portfolio";
import AdminPage from "@/admin/AdminPage";

function ScrollToTop() {
  const location = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname, lenis]);
  return null;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/az-studio-admin" element={<AdminPage />} />
      <Route path="*" element={
        <PageShell>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/studio" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/process" element={<ProcessPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </PageShell>
      } />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AdminAuthProvider>
        <PortfolioProvider>
          <ReactLenis
            root
            options={{
              duration: 1.2,
              easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
              smoothWheel: true,
              smoothTouch: false,
              lerp: 0.1,
            }}
          >
            <div className="App grain">
              <Cursor />
              <BrowserRouter>
                <ScrollToTop />
                <AppRoutes />
              </BrowserRouter>
            </div>
          </ReactLenis>
        </PortfolioProvider>
      </AdminAuthProvider>
    </LanguageProvider>
  );
}

export default App;
